/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePartnerJoinRequestDto } from '../../models/create-partner-join-request-dto';
import { PartnerJoinRequestDto } from '../../models/partner-join-request-dto';

export interface PartnerJoinRequestControllerCreate$Params {
      body: CreatePartnerJoinRequestDto
}

export function partnerJoinRequestControllerCreate(http: HttpClient, rootUrl: string, params: PartnerJoinRequestControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<PartnerJoinRequestDto>> {
  const rb = new RequestBuilder(rootUrl, partnerJoinRequestControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PartnerJoinRequestDto>;
    })
  );
}

partnerJoinRequestControllerCreate.PATH = '/api/partner-join-request';
